"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
// locals
var util_1 = require("../util");
var configuration_1 = require("../configuration");
var ui_1 = require("../ui");
// icons
var Settings_1 = __importDefault(require("@mui/icons-material/Settings"));
var Help_1 = __importDefault(require("@mui/icons-material/Help"));
// lazies
var SettingsDlg = (0, react_1.lazy)(function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./SequenceFeatureSettingsDialog'));
  });
});
var HelpDlg = (0, react_1.lazy)(function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./SequenceHelpDialog'));
  });
});
var SequencePanel = (0, react_1.lazy)(function () {
  return Promise.resolve().then(function () {
    return __importStar(require('./SequencePanel'));
  });
});
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    formControl: {
      margin: 0
    },
    container: {
      margin: theme.spacing(1)
    },
    container2: {
      marginTop: theme.spacing(1)
    }
  };
});
var BPLIMIT = 500000;
// display the stitched-together sequence of a gene's CDS, cDNA, or protein
// sequence. this is a best effort and weird genomic phenomena could lead these
// to not be 100% accurate
function SequenceFeatureDetails(_ref) {
  var model = _ref.model,
    feature = _ref.feature;
  var _a;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var parentFeature = feature;
  var hasCDS = !!((_a = parentFeature.subfeatures) === null || _a === void 0 ? void 0 : _a.find(function (sub) {
    return sub.type === 'CDS';
  }));
  var isGene = feature.type === 'gene';
  var _ref2 = (0, react_1.useState)(false),
    _ref3 = _slicedToArray(_ref2, 2),
    shown = _ref3[0],
    setShown = _ref3[1];
  var _ref4 = (0, react_1.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    helpShown = _ref5[0],
    setHelpShown = _ref5[1];
  return isGene && !hasCDS || !model ? null : react_1.default.createElement("div", {
    className: classes.container2
  }, react_1.default.createElement(material_1.Button, {
    variant: "contained",
    onClick: function onClick() {
      return setShown(!shown);
    }
  }, shown ? 'Hide feature sequence' : 'Show feature sequence'), react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.IconButton, {
    onClick: function onClick() {
      return setHelpShown(true);
    }
  }, react_1.default.createElement(Help_1.default, null))), react_1.default.createElement("br", null), shown ? react_1.default.createElement(FeatureSequence, {
    model: model,
    feature: feature
  }) : null, helpShown ? react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement("div", null)
  }, react_1.default.createElement(HelpDlg, {
    handleClose: function handleClose() {
      return setHelpShown(false);
    }
  })) : null);
}
exports.default = SequenceFeatureDetails;
function FeatureSequence(_ref6) {
  var model = _ref6.model,
    feature = _ref6.feature;
  var _a;
  var _useStyles2 = useStyles(),
    classes = _useStyles2.classes;
  var parentFeature = feature;
  var hasCDS = !!((_a = parentFeature.subfeatures) === null || _a === void 0 ? void 0 : _a.find(function (sub) {
    return sub.type === 'CDS';
  }));
  var seqPanelRef = (0, react_1.useRef)(null);
  var _ref7 = (0, react_1.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    settingsDlgOpen = _ref8[0],
    setSettingsDlgOpen = _ref8[1];
  var _ref9 = (0, util_1.useLocalStorage)('intronBp', 10),
    _ref10 = _slicedToArray(_ref9, 2),
    intronBp = _ref10[0],
    setIntronBp = _ref10[1];
  var _ref11 = (0, util_1.useLocalStorage)('upDownBp', 500),
    _ref12 = _slicedToArray(_ref11, 2),
    upDownBp = _ref12[0],
    setUpDownBp = _ref12[1];
  var _ref13 = (0, react_1.useState)(),
    _ref14 = _slicedToArray(_ref13, 2),
    sequence = _ref14[0],
    setSequence = _ref14[1];
  var _ref15 = (0, react_1.useState)(),
    _ref16 = _slicedToArray(_ref15, 2),
    error = _ref16[0],
    setError = _ref16[1];
  var _ref17 = (0, react_1.useState)(false),
    _ref18 = _slicedToArray(_ref17, 2),
    copied = _ref18[0],
    setCopied = _ref18[1];
  var _ref19 = (0, react_1.useState)(false),
    _ref20 = _slicedToArray(_ref19, 2),
    copiedHtml = _ref20[0],
    setCopiedHtml = _ref20[1];
  var _ref21 = (0, react_1.useState)({
      id: feature.uniqueId,
      force: false
    }),
    _ref22 = _slicedToArray(_ref21, 2),
    forceLoad = _ref22[0],
    setForceLoad = _ref22[1];
  (0, react_1.useEffect)(function () {
    setForceLoad({
      id: feature.uniqueId,
      force: false
    });
  }, [feature]);
  (0, react_1.useEffect)(function () {
    var _a;
    var finished = false;
    if (!model) {
      return function () {};
    }
    var _ref23 = (0, util_1.getSession)(model),
      assemblyManager = _ref23.assemblyManager,
      rpcManager = _ref23.rpcManager;
    var _ref24 = ((_a = model.view) === null || _a === void 0 ? void 0 : _a.assemblyNames) || [],
      _ref25 = _slicedToArray(_ref24, 1),
      assemblyName = _ref25[0];
    function fetchSeq(_x, _x2, _x3) {
      return _fetchSeq.apply(this, arguments);
    } // eslint-disable-next-line @typescript-eslint/no-floating-promises
    function _fetchSeq() {
      _fetchSeq = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(start, end, refName) {
        var assembly, sessionId, feats, _feats, feat;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return assemblyManager.waitForAssembly(assemblyName);
            case 2:
              assembly = _context2.sent;
              if (assembly) {
                _context2.next = 5;
                break;
              }
              throw new Error('assembly not found');
            case 5:
              sessionId = 'getSequence';
              _context2.next = 8;
              return rpcManager.call(sessionId, 'CoreGetFeatures', {
                adapterConfig: (0, configuration_1.getConf)(assembly, ['sequence', 'adapter']),
                sessionId: sessionId,
                regions: [{
                  start: start,
                  end: end,
                  refName: assembly.getCanonicalRefName(refName),
                  assemblyName: assemblyName
                }]
              });
            case 8:
              feats = _context2.sent;
              _feats = _slicedToArray(feats, 1), feat = _feats[0];
              return _context2.abrupt("return", (feat === null || feat === void 0 ? void 0 : feat.get('seq')) || '');
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchSeq.apply(this, arguments);
    }
    ;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var start, end, refName, seq, up, down;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setError(undefined);
            start = feature.start, end = feature.end, refName = feature.refName;
            if (!(!forceLoad.force && end - start > BPLIMIT)) {
              _context.next = 7;
              break;
            }
            setSequence({
              error: "Genomic sequence larger than ".concat(BPLIMIT, "bp, use \"force load\" button to display")
            });
            _context.next = 17;
            break;
          case 7:
            _context.next = 9;
            return fetchSeq(start, end, refName);
          case 9:
            seq = _context.sent;
            _context.next = 12;
            return fetchSeq(Math.max(0, start - upDownBp), start, refName);
          case 12:
            up = _context.sent;
            _context.next = 15;
            return fetchSeq(end, end + upDownBp, refName);
          case 15:
            down = _context.sent;
            if (!finished) {
              setSequence({
                seq: seq,
                upstream: up,
                downstream: down
              });
            }
          case 17:
            _context.next = 23;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            setError(_context.t0);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 19]]);
    }))();
    return function () {
      finished = true;
    };
  }, [feature, model, upDownBp, forceLoad]);
  var loading = !sequence;
  var session = (0, util_1.getSession)(model);
  var defaultSeqTypes = ['mRNA', 'transcript', 'gene'];
  var sequenceTypes = (0, configuration_1.getConf)(session, ['featureDetails', 'sequenceTypes']) || defaultSeqTypes;
  // only attempt fetching gene type sequence on a bare CDS if it has no parent
  var attemptGeneType = feature.type === 'CDS' ? sequenceTypes.includes('CDS') && !feature.parentId : sequenceTypes.includes(feature.type);
  var val = attemptGeneType ? hasCDS ? 'cds' : 'cdna' : 'genomic';
  // this useEffect is needed to reset the mode/setMode useState because the
  // contents of the select box can completely change depending on whether we
  // click on a gene feature or non-gene feature, so the current value in the
  // select box must change accordingly
  (0, react_1.useEffect)(function () {
    setMode(val);
  }, [attemptGeneType, val]);
  var _ref27 = (0, react_1.useState)(attemptGeneType ? hasCDS ? 'cds' : 'cdna' : 'genomic'),
    _ref28 = _slicedToArray(_ref27, 2),
    mode = _ref28[0],
    setMode = _ref28[1];
  var rest = {
    gene: 'Gene w/ introns',
    gene_collapsed_intron: "Gene w/ ".concat(intronBp, "bp of intron"),
    gene_updownstream: "Gene w/ ".concat(upDownBp, "bp up+down stream"),
    gene_updownstream_collapsed_intron: "Gene w/ ".concat(upDownBp, "bp up+down stream w/ ").concat(intronBp, "bp intron"),
    cdna: 'cDNA'
  };
  var arg = attemptGeneType ? hasCDS ? _objectSpread({
    cds: 'CDS',
    protein: 'Protein'
  }, rest) : rest : {
    genomic: 'Genomic seq',
    genomic_sequence_updown: "Genomic seq w/ ".concat(upDownBp, "bp up+down stream")
  };
  return react_1.default.createElement("div", {
    className: classes.container2
  }, react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.Select, {
    value: mode,
    onChange: function onChange(event) {
      return setMode(event.target.value);
    }
  }, Object.entries(arg).map(function (_ref29) {
    var _ref30 = _slicedToArray(_ref29, 2),
      key = _ref30[0],
      val = _ref30[1];
    return react_1.default.createElement(material_1.MenuItem, {
      key: key,
      value: key
    }, val);
  }))), react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.Button, {
    className: classes.button,
    variant: "contained",
    onClick: function onClick() {
      var ref = seqPanelRef.current;
      if (ref) {
        (0, copy_to_clipboard_1.default)(ref.textContent || '', {
          format: 'text/plain'
        });
        setCopied(true);
        setTimeout(function () {
          return setCopied(false);
        }, 1000);
      }
    }
  }, copied ? 'Copied to clipboard!' : 'Copy plaintext')), react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.Tooltip, {
    title: "The 'Copy HTML' function retains the colors from the sequence panel but cannot be pasted into some programs like notepad that only expect plain text"
  }, react_1.default.createElement(material_1.Button, {
    className: classes.button,
    variant: "contained",
    onClick: function onClick() {
      var ref = seqPanelRef.current;
      if (ref) {
        (0, copy_to_clipboard_1.default)(ref.innerHTML, {
          format: 'text/html'
        });
        setCopiedHtml(true);
        setTimeout(function () {
          return setCopiedHtml(false);
        }, 1000);
      }
    }
  }, copiedHtml ? 'Copied to clipboard!' : 'Copy HTML'))), react_1.default.createElement(material_1.FormControl, {
    className: classes.formControl
  }, react_1.default.createElement(material_1.IconButton, {
    onClick: function onClick() {
      return setSettingsDlgOpen(true);
    }
  }, react_1.default.createElement(Settings_1.default, null))), react_1.default.createElement("br", null), error ? react_1.default.createElement(material_1.Typography, {
    color: "error"
  }, "".concat(error)) : loading ? react_1.default.createElement(ui_1.LoadingEllipses, null) : sequence ? 'error' in sequence ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Typography, {
    color: "error"
  }, sequence.error), react_1.default.createElement(material_1.Button, {
    variant: "contained",
    color: "inherit",
    onClick: function onClick() {
      return setForceLoad(_objectSpread({}, forceLoad, {
        force: true
      }));
    }
  }, "Force load")) : react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement("div", null, "Loading")
  }, react_1.default.createElement(SequencePanel, {
    ref: seqPanelRef,
    feature: parentFeature,
    mode: mode,
    sequence: sequence,
    intronBp: intronBp
  })) : react_1.default.createElement(material_1.Typography, null, "No sequence found"), settingsDlgOpen ? react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement("div", null)
  }, react_1.default.createElement(SettingsDlg, {
    handleClose: function handleClose(arg) {
      if (arg) {
        var _upDownBp = arg.upDownBp,
          _intronBp = arg.intronBp;
        setIntronBp(_intronBp);
        setUpDownBp(_upDownBp);
      }
      setSettingsDlgOpen(false);
    },
    upDownBp: upDownBp,
    intronBp: intronBp
  })) : null);
}